import { DeleteRosterCalendarIcon } from '@/components/shared/icons/DeleteRosterCalendarIcon';
import { FC } from 'react';

interface DeleteButtonProps {
  onClick: () => void;
}

export const DeleteButton: FC<DeleteButtonProps> = ({ onClick }) => {
  return (
    <div className="absolute w-full h-full opacity-0 hover:opacity-100 top-0">
      <DeleteRosterCalendarIcon
        onClick={event => {
          event.stopPropagation();
          onClick();
        }}
        className="absolute right-0 m-1"
      />
    </div>
  );
};
